(function () {
  function init(root) {
    var rail = root.querySelector('[data-rail]');
    var columns = Array.prototype.slice.call(root.querySelectorAll('.ctable__phead'));
    var rows = Array.prototype.slice.call(root.querySelectorAll('.ctable__row'));
    var diffToggle = root.querySelector('[data-diff-toggle]');

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
    var count = root.querySelector('[data-visible-count]');
    var pickers = Array.prototype.slice.call(root.querySelectorAll('[data-compare-pick]'));
    var pickedBox = root.querySelector('[data-picked]');
    var pickedText = root.querySelector('[data-picked-text]');
    var applyBtn = root.querySelector('[data-apply-compare]');
    var activeTab = 'all';
    var applied = false;

    function isPicked(btn) {
      return btn.getAttribute('aria-pressed') === 'true';
    }

    function setPicked(btn, on) {
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    function picks() {
      return pickers.filter(isPicked);
    }

    function render(scrollToStart) {
      var chosen = picks().map(function (box) { return box.value; });
      var comparing = applied && chosen.length >= 2;
      var shown = 0;

      columns.forEach(function (head) {
        var col = head.dataset.col;
        var match = comparing
          ? chosen.indexOf(col) !== -1
          : activeTab === 'all' || head.dataset.category === activeTab;
        var cells = root.querySelectorAll('[data-col="' + col + '"]');
        Array.prototype.forEach.call(cells, function (cell) {
          cell.hidden = !match;
        });
        if (match) shown++;
      });

      if (count) count.textContent = shown;
      if (pickedBox) {
        pickedBox.hidden = chosen.length === 0;
        if (pickedText) {
          pickedText.textContent = comparing
            ? 'Comparing ' + chosen.length + ' of ' + columns.length
            : chosen.length < 2
              ? '1 selected — pick one more'
              : chosen.length + ' selected';
        }
        if (applyBtn) {
          applyBtn.hidden = chosen.length < 2;
          applyBtn.textContent = comparing
            ? applyBtn.dataset.labelReset || 'Show all'
            : applyBtn.dataset.labelApply || 'Compare these';
        }
      }
      if (rail && scrollToStart) rail.scrollTo({ left: 0, behavior: 'smooth' });
      applyDiff();
      measure();
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (other) {
          var on = other === tab;
          other.classList.toggle('is-active', on);
          other.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        activeTab = tab.dataset.filter;
        pickers.forEach(function (btn) { setPicked(btn, false); });
        applied = false;
        render(true);
      });
    });

    pickers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setPicked(btn, !isPicked(btn));
        var wasApplied = applied;
        if (applied && picks().length < 2) applied = false;
        render(wasApplied !== applied);
      });
    });

    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        applied = !applied;
        render(true);
      });
    }

    var clearBtn = root.querySelector('[data-clear-compare]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        pickers.forEach(function (btn) { setPicked(btn, false); });
        applied = false;
        render(true);
      });
    }

    function allEqual(row) {
      var cells = Array.prototype.filter.call(row.querySelectorAll('.ctable__cell'), function (cell) {
        return !cell.hidden;
      });
      if (cells.length < 2) return true;
      var first = cells[0].textContent.trim();
      for (var i = 1; i < cells.length; i++) {
        if (cells[i].textContent.trim() !== first) return false;
      }
      return true;
    }

    var groupRows = Array.prototype.slice.call(root.querySelectorAll('[data-group]'));

    function syncGroups() {
      groupRows.forEach(function (group) {
        var hasVisibleRow = false;
        var node = group.nextElementSibling;
        while (node && !node.hasAttribute('data-group')) {
          if (node.classList.contains('ctable__row') && !node.hidden) {
            hasVisibleRow = true;
            break;
          }
          node = node.nextElementSibling;
        }
        group.hidden = !hasVisibleRow;
      });
    }

    function applyDiff() {
      if (diffToggle) {
        var on = diffToggle.checked;
        rows.forEach(function (row) {
          row.hidden = on && allEqual(row);
        });
      }
      syncGroups();
    }

    if (diffToggle) diffToggle.addEventListener('change', applyDiff);
    syncGroups();

    if (!rail) return;
    var foot = root.querySelector('[data-railfoot]');
    var bar = root.querySelector('[data-bar]');
    var thumb = root.querySelector('[data-thumb]');
    var arrows = Array.prototype.slice.call(root.querySelectorAll('[data-rail-scroll]'));

    function overflow() {
      return rail.scrollWidth - rail.clientWidth;
    }

    function measure() {
      var max = overflow();
      var scrollable = max > 1;
      if (foot) {
        if (scrollable) foot.setAttribute('data-scrollable', '');
        else foot.removeAttribute('data-scrollable');
      }
      if (scrollable) rail.setAttribute('data-scrollable', '');
      else rail.removeAttribute('data-scrollable');
      if (thumb) {
        thumb.style.width = scrollable ? (rail.clientWidth / rail.scrollWidth) * 100 + '%' : '100%';
      }
      syncMiniWidths();
      paint();
      paintMini();
    }

    function paint() {
      var max = overflow();
      if (miniTrack) miniTrack.style.transform = 'translateX(' + -rail.scrollLeft + 'px)';
      if (thumb && bar) {
        var ratio = max > 0 ? rail.scrollLeft / max : 0;
        var travel = bar.clientWidth - thumb.offsetWidth;
        thumb.style.transform = 'translateX(' + travel * ratio + 'px)';
      }
      arrows.forEach(function (btn) {
        var dir = Number(btn.dataset.railScroll);
        btn.disabled = max <= 1 || (dir < 0 ? rail.scrollLeft <= 1 : rail.scrollLeft >= max - 1);
      });
    }

    arrows.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var head = columns.find(function (col) { return !col.hidden; });
        var step = head ? head.getBoundingClientRect().width : rail.clientWidth * 0.8;
        rail.scrollBy({ left: step * Number(btn.dataset.railScroll), behavior: 'smooth' });
      });
    });

    rail.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', measure);

    var mini = root.querySelector('[data-ministick]');
    var miniTrack = root.querySelector('[data-ministick-track]');
    var miniLead = root.querySelector('[data-ministick-lead]');
    var thead = root.querySelector('.ctable__table thead');
    var table = root.querySelector('.ctable__table');

    function headerOffset() {
      var header = document.querySelector('.header--sticky');
      if (!header) return 0;
      var box = header.closest('.shopify-section') || header;
      if (getComputedStyle(box).position !== 'sticky') return 0;
      return Math.round(box.getBoundingClientRect().height);
    }

    var stickTop = null;
    function setStickTop(px) {
      if (px === stickTop) return;
      stickTop = px;
      root.style.setProperty('--ctable-stick-top', px + 'px');
    }

    function syncMiniWidths() {
      if (!mini) return;
      var offset = headerOffset();
      var labelCell = root.querySelector('.ctable__rlabel');
      var leadWidth = miniLead && labelCell ? labelCell.offsetWidth : null;
      var measured = columns.map(function (head) {
        return {
          cell: mini.querySelector('.cmini[data-col="' + head.dataset.col + '"]'),
          width: head.offsetWidth,
        };
      });

      setStickTop(offset);
      if (leadWidth !== null) miniLead.style.width = leadWidth + 'px';
      measured.forEach(function (entry) {
        if (entry.cell) entry.cell.style.width = entry.width + 'px';
      });
    }

    function paintMini() {
      if (!mini || !thead || !table) return;
      var scrolled = rail.scrollLeft;
      var offset = headerOffset();
      var strip = mini.firstElementChild ? mini.firstElementChild.offsetHeight : 60;
      var theadBottom = thead.getBoundingClientRect().bottom;
      var tableBottom = table.getBoundingClientRect().bottom;
      var on = theadBottom < offset && tableBottom > offset + strip;

      if (miniTrack) miniTrack.style.transform = 'translateX(' + -scrolled + 'px)';
      setStickTop(offset);
      mini.classList.toggle('is-on', on);
    }

    if (mini) {
      var queued = false;
      var onScroll = function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          paintMini();
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      rail.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }

    var drag = null;

    rail.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      if (overflow() <= 1) return;
      if (event.target.closest('input, select, textarea, [contenteditable]')) return;
      drag = { x: event.clientX, left: rail.scrollLeft, moved: false, id: event.pointerId };
      rail.classList.add('is-grabbing');
    });

    rail.addEventListener('pointermove', function (event) {
      if (!drag || event.pointerId !== drag.id) return;
      var dx = event.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) < 4) return;
      if (!drag.moved) {
        drag.moved = true;
        if (rail.setPointerCapture) rail.setPointerCapture(event.pointerId);
      }
      rail.scrollLeft = drag.left - dx;
      event.preventDefault();
    });

    function endDrag() {
      if (!drag) return;
      rail.dataset.dragged = drag.moved ? '1' : '';
      drag = null;
      rail.classList.remove('is-grabbing');
    }
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (type) {
      rail.addEventListener(type, endDrag);
    });

    rail.addEventListener(
      'click',
      function (event) {
        if (rail.dataset.dragged === '1') {
          event.preventDefault();
          event.stopPropagation();
          rail.dataset.dragged = '';
        }
      },
      true
    );

    if (bar && thumb) {
      var dragging = false;

      function seek(clientX) {
        var rect = bar.getBoundingClientRect();
        var travel = rect.width - thumb.offsetWidth;
        if (travel <= 0) return;
        var pos = clientX - rect.left - thumb.offsetWidth / 2;
        var ratio = Math.min(1, Math.max(0, pos / travel));
        rail.scrollLeft = overflow() * ratio;
      }

      bar.addEventListener('pointerdown', function (event) {
        dragging = true;
        bar.setPointerCapture(event.pointerId);
        seek(event.clientX);
      });
      bar.addEventListener('pointermove', function (event) {
        if (dragging) seek(event.clientX);
      });
      ['pointerup', 'pointercancel'].forEach(function (type) {
        bar.addEventListener(type, function () { dragging = false; });
      });
    }

    render(false);
    window.addEventListener('load', measure);
  }

  function boot() {
    document.querySelectorAll('[data-comparison-table]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
